<template>
  <div class="agreement-content">
    <div class="agreement-container">
      <div class="step">
        <el-steps :active="0" class="step-container" align-center>
          <el-step title="维护商品"></el-step>
          <el-step title="审核商品"></el-step>
          <el-step title="协议生效"></el-step>
        </el-steps>
      </div>
    </div>
    <div class="agreement-container">
      <div class="container-title">主体信息</div>
      <div class="container-body">
        <el-form label-width="100px" :inline="true">
          <el-col :span="8">
            <el-form-item label="协议编号:">
              <div class="ellipsis">{{ agreementDetail.agreementCode }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议名称:">
              <div class="ellipsis">{{ agreementDetail.agreementName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议甲方企业:">
              <div class="ellipsis">{{ agreementDetail.firstCompanyName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议乙方企业:">
              <div class="ellipsis">
                {{ agreementDetail.secondCompanyName }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="乙方来源:">
              <div class="ellipsis">
                {{ formatSource(agreementDetail.secondCompanySource) }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="乙方类型:">
              <div class="ellipsis">
                {{ formatSecondCompanyType(agreementDetail.secondCompanyType) }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议有效时间:" prop="date">
              <div class="ellipsis">
                {{ agreementDetail.startDate + '至' + agreementDetail.endDate }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务费率:" prop="date">
              <div class="ellipsis">
                {{ agreementDetail.serviceRate + '%' }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="协议状态:" prop="date">
              <div class="ellipsis">
                {{ formatStatus(agreementDetail.agreementStatus) }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注:" prop="remark">
              <div class="ellipsis">{{ agreementDetail.remark }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件:">
              <el-button type="text" @click="checkAttachList">查看附件列表</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button style="margin-left: 30px" type="text" @click="checkCategoryList">查看物料分类清单</el-button>
          </el-col>
        </el-form>
      </div>
    </div>

    <div class="agreement-container">
      <div class="container-title">维护商品</div>

      <div class="search_box" style="">
        <e-search
          :data="query"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          :width="listTypeInfo.width"
          :btn-style="btnStyle"
          @handleFilter="handleSearch"
          @handleReset="handleClear"
          @handleFocus="focusClassify"
          @handleExport="exportFile"
        >
          <template #extra>
            <div class="flex sku_code">
              <p class="text">商品编码：</p>
              <el-input
                v-model.trim="query.code"
                clearable
                class="text_input pre-line"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请输入商品编码"
                @input="inputChange"
              ></el-input>
            </div>
          </template>
        </e-search>
      </div>
      <div class="container-btn">
        <el-button type="primary" @click="handleAddProduct">新增</el-button>
        <el-button type="primary" :loading="btnLoading" @click="openImportDialog(1)">导入</el-button>
        <el-button type="primary" @click="openImportDialog(2)">导入调价</el-button>
        <el-button type="primary" @click="handleMultiAdjustPrice">调价</el-button>
        <el-button type="primary" @click="delHandle">批量删除</el-button>
        <el-button type="primary" @click="handleDisable">批量停用</el-button>
        <el-button type="text" @click="openResultDialog">查看导入结果</el-button>
      </div>

      <div class="container-body">
        <div style="margin-right: 20px">
          <TableList
            ref="tableList"
            :loading="loading1"
            :table-data="tableData1"
            :table-label="tableLabel1"
            :selection-show="true"
            :row-key="'skuId'"
            :reserve-selection="true"
            @handleButton="handleButton1"
            @handleSortChange="handleSortChange1"
            @handleSelectionChange="handleSelectionChange1"
            @handleSelect="handleSelect"
          >
            <template #skuName="slot">
              <div class="table-product-name">
                {{ slot.scope.row.skuName }}
              </div>
            </template>
            <template #status="slot">
              {{ formatConfirmStatus(slot.scope.row.confirmStatus) }}
            </template>
            <template #operateSign="slot">
              {{ formatOperateSign(slot.scope.row.operateSign) }}
            </template>
            <template #collectPrice="{ scope: { row } }">
              <span>{{ row.collectPrice && row.collectPrice !== 0 ? row.collectPrice : '--' }}</span>
            </template>
            <template #operation="slot">
              <el-button
                v-if="slot.scope.row.companyShowStatus == '正常'"
                type="text"
                @click="handleStop(slot.scope.row)"
              >
                停用
              </el-button>
              <el-button
                v-if="slot.scope.row.companyShowStatus == '供应商停用'"
                type="text"
                @click="handleStart(slot.scope.row)"
              >
                启用
              </el-button>
              <!--拒绝商品、平台停用、供应商停用  可以删除-->
              <el-button
                v-if="slot.scope.row.confirmStatus === 0 && slot.scope.row.companyShowStatus === '新增'"
                type="text"
                @click="delHandle(slot.scope.row)"
              >
                删除
              </el-button>
            </template>
          </TableList>
          <div style="float: left; margin-left: 10px; margin-top: 30px">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange">勾选全部页下的数据</el-checkbox>
          </div>
          <div class="pagination">
            <el-pagination
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="productTagPage1.currentPage"
              :page-size="productTagPage1.pageSize"
              :total="productTagPage1.pageTotal"
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="agreement-container">
      <div class="container-title">操作记录</div>

      <div class="container-body">
        <el-form label-width="100px" :inline="true">
          <el-col :span="12">
            <el-form-item label="创建人:">
              {{ agreementDetail.createUser }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间:">
              {{ agreementDetail.createTime }}
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>

    <div style="margin-top: 10px">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">提交</el-button>
    </div>
    <AddProductDialog
      v-if="productListDialogShow"
      :material-code="materialCode"
      :agreement-detail="agreementDetail"
      :visible="productListDialogShow"
      @close="closeProductListDialog"
      @refreshProduct="getProductPriceList"
    />
    <AdjustPriceDialog
      v-if="adjustPriceDialogShow"
      :agreement-id="agreementId"
      :visible="adjustPriceDialogShow"
      :price-id="priceId"
      :supplier-company-id="supplierCompanyId"
      @close="closeAdjustPriceDialog"
      @refresh="getProductPriceList"
    />
    <MultiAdjustPriceDialog
      v-if="multiAdjustPriceDialogShow"
      ref="multiAdjustPrice"
      :visible="multiAdjustPriceDialogShow"
      :price="adjustPrice"
      @handleAdjustPrice="multiAdjustPrice"
      @close="handleClose"
    ></MultiAdjustPriceDialog>
    <AttachListDialog
      v-if="checkAttachDialog"
      :agreement-id="agreementId"
      :visible="checkAttachDialog"
      @close="
        () => {
          checkAttachDialog = false;
        }
      "
    />
    <CategoryListDialog
      v-if="checkCategoryDialog"
      :agreement-id="agreementId"
      :visible="checkCategoryDialog"
      @close="
        () => {
          checkCategoryDialog = false;
        }
      "
    />
    <!-- 所属分类 -->
    <classifyTree
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    />

    <!-- 批量导入 -->
    <batch-import
      :import-type="importType"
      :batch-import-visible.sync="batchImportVisible"
      @getBatchImportResult="getBatchImportResult"
    />

    <!-- 导入结果 -->
    <result-dialog :result-visible.sync="resultVisible" />
  </div>
</template>

<script>
import utils from '@/modules/projectA/utils/utils';
import _ from 'lodash';
import { Message } from 'element-ui';
import TableList from '../../components/common/e-table-list';
import ESearch from '../../components/common/e-search';
import Api from '../../api/agreement/index';
import AddProductDialog from '../../components/agreement/agreementManage/sharedResourceProductAddDialog';
import AdjustPriceDialog from '../../components/agreement/agreementManage/adjustPriceDialog';
import MultiAdjustPriceDialog from './components/multiAdjustPriceDialog';
import AttachListDialog from '../../components/agreement/agreementManage/attachListDialog';
import CategoryListDialog from '../../components/agreement/agreementManage/categoryListDialog';
import ClassifyTree from '../../components/agreement/agreementManage/classifyTree';
import BatchImport from './components/batchImport.vue';
import ResultDialog from './components/result.vue';

export default {
  name: 'SharedResourceGoodsMaintenance',
  components: {
    TableList,
    AddProductDialog,
    AdjustPriceDialog,
    MultiAdjustPriceDialog,
    AttachListDialog,
    CategoryListDialog,
    ClassifyTree,
    ESearch,
    BatchImport,
    ResultDialog,
  },
  props: {},
  data() {
    return {
      agreementDetail: '',
      loading: false,
      tableData: [],
      tableLabel: [{ label: '企业名称', param: 'companyName', align: 'center' }],
      loading1: true,
      tableData1: [],
      tableLabel1: [
        { label: '商品编号', param: 'skuCode', align: 'center' },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
          slot: 'skuName',
          width: '200',
        },

        { label: '类目名称', param: 'categoryName', align: 'center' },

        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '品牌', param: 'brandName', align: 'center' },
        { label: '平台价（元）', param: 'skuPrice', align: 'center' },
        {
          label: '协议价（元）',
          param: 'agreementTempPrice',
          align: 'center',
          render: (row) => {
            // 商品的协议价自动带入，默认协议价=平台价
            return row.agreementTempPrice || row.skuPrice;
          },
        },
        { label: '集采价（元）', align: 'center', slot: 'collectPrice' },
        {
          label: '来源',
          param: '',
          align: 'center',
          render: (row) => {
            if (row.systemSign === 1) {
              return '2.0';
            }
            if (row.systemSign === 0) {
              return '保供协议';
            }
          },
        },
        { label: '商品状态', param: 'companyShowStatus', align: 'center' },
        { label: '记录状态', param: 'status', align: 'center', slot: 'status' },
        { label: '操作', align: 'center', slot: 'operation' },
      ],
      productTagPage1: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      agreementConfirm: 1,
      indexShow: true,
      agreementId: this.$route.params.agreementId,
      productListDialogShow: false,
      priceId: '',
      adjustPriceDialogShow: false,
      supplierCompanyId: '',
      quickNavActive: 0,
      pager: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      agreementPrice: '',
      checkAll: false,
      multiAdjustPriceDialogShow: false,
      checkedSkuPriceMap: [],
      adjustPrice: 0,
      checkAllCount: 0,
      query: {
        code: '',
        skuCode: '',
        skuName: '',
        categoryName: '',
        brandName: '',
        categoryIdList: null,
        companyShowCode: '',
        confirmStatus: '',
        skuCodeList: [],
        priceCompareFlag: null,
        systemSign: null,
      },
      checkAttachDialog: false,
      checkCategoryDialog: false,
      attachmentList: [],
      categoryList: [],
      // 所属分类
      classifyVisible: false,
      classifyData: null,
      defaultCheckedKeys: [],
      categoryTreeData: [],
      fieldList: [
        // { label: "商品编码", type: "input", value: "skuCode", placeholder: "支持模糊搜索" },
        {
          label: '商品名称',
          type: 'input',
          value: 'skuName',
          placeholder: '支持模糊搜索',
        },
        {
          label: '类目名称',
          type: 'dialog',
          value: 'categoryName',
          placeholder: '支持多选',
        },
        {
          label: '品牌名称',
          type: 'input',
          value: 'brandName',
          placeholder: '支持模糊搜索',
        },
        // skuStatus 1-正常, 2-供应商停用, 3-平台停用
        {
          label: '商品状态',
          type: 'select',
          value: 'companyShowCode',
          placeholder: '请选择',
          list: 'companyShowCodeList',
        },
        {
          label: '记录状态',
          type: 'select',
          value: 'confirmStatus',
          placeholder: '请选择',
          list: 'confirmStatusList',
        },
        {
          label: '来源',
          type: 'select',
          value: 'systemSign',
          placeholder: '请选择',
          list: 'sourceList',
        },
        {
          label: '价格比较',
          type: 'select',
          value: 'priceCompareFlag',
          placeholder: '请选择',
          list: 'comparePriceList',
        },
      ],

      listTypeInfo: {
        width: {
          labelWidth: 90,
          itemWidth: 200,
        },
        sourceList: [
          { id: null, name: '全部' },
          { id: 1, name: '2.0' },
          { id: 0, name: '保供协议' },
        ],
        comparePriceList: [
          { id: null, name: '全部' },
          { id: 1, name: '协议价 < 平台价' },
          { id: 2, name: '协议价 = 平台价' },
          { id: 3, name: '协议价 > 平台价' },
        ],
        // 商品状态 companyShowCode 商品状态：1:平台停用,2:供应商停用，3:正常，4:新增，5:调价
        companyShowCodeList: [
          {
            id: 1,
            name: '平台停用',
          },
          {
            id: 2,
            name: '供应商停用',
          },
          {
            id: 3,
            name: '正常',
          },
          {
            id: 4,
            name: '新增',
          },
          {
            id: 5,
            name: '调价',
          },
        ],
        // 记录状态: 0-待提交，1-待确认，2-已确认
        confirmStatusList: [
          {
            id: 0,
            name: '待提交',
          },
          {
            id: 1,
            name: '待确认',
          },
          {
            id: 2,
            name: '已确认',
          },
          {
            id: 3,
            name: '拒绝',
          },
        ],
      },
      btnStyle: [
        { icon: null, text: '重置' },
        { icon: null, text: '查询', type: 'primary' },

        { icon: null, text: '导出', type: 'primary' },
      ],
      materialCode: '',
      //
      batchImportVisible: false,
      btnLoading: false,
      resultVisible: false,
      importType: 1,
    };
  },
  computed: {},
  created() {
    this.agreementId = this.$route.query.agreementId;
    this.getAgreementDetail();

    this.getProductPriceList();
  },
  mounted() {
    // this.agreementId = this.$route.query.agreementId;
    // this.getAgreementDetail();
    // this.getProductPriceList();
  },
  methods: {
    handleButton() {},
    handleSortChange() {},
    handleSelectionChange() {},
    handleButton1() {},
    handleSortChange1() {},

    //
    async openImportDialog(type) {
      this.importType = type;
      try {
        let res;
        if (type === 1) {
          res = await Api.checkLoading();
        } else if (type === 2) {
          res = await Api.checkChangePriceLoading();
        }

        Message.closeAll();
        if (+res.code === 200) {
          this.batchImportVisible = true;
        } else {
          this.$message('商品导入中，请稍后在【查看导入结果】下载查看导入结果');
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 得到批量导入后的数据
    getBatchImportResult() {
      this.handleClear();
    },
    openResultDialog() {
      this.resultVisible = true;
    },
    handleSelectionChange1(val) {
      this.checkedSkuPriceMap = val;
    },
    handleSizeChange1(val) {
      this.productTagPage1.pageSize = val;
      this.productTagPage1.currentPage = 1;
      this.getProductPriceList();
    },
    handleCurrentChange1(val) {
      this.productTagPage1.currentPage = val;
      this.getProductPriceList();
    },
    formatConfirmStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待提交';
          break;
        case 1:
          res = '待确认';
          break;
        case 2:
          res = '已确认';
          break;
        case 3:
          res = '拒绝';
          break;
        case 4:
          res = '已停用';
          break;
      }
      return res;
    },
    formatOperateSign(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '新增';
          break;
        case 1:
          res = '调价';
          break;
        case 2:
          res = '删除';
          break;
      }
      return res;
    },
    // getProductPriceList调用
    async getProductPriceList() {
      this.clearTable();
      let arr = [];
      if (this.query.code) {
        const s = this.query.code.replace(/\n/g, '@');
        arr = s.split('@');
      }
      const params = {
        agreementId: this.agreementId,
        pageSize: this.productTagPage1.pageSize,
        pageNum: this.productTagPage1.currentPage,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
        brandName: this.query.brandName,
        companyShowCode: this.query.companyShowCode,
        confirmStatus: this.query.confirmStatus,
        skuCodeList: arr,
        systemSign: this.query.systemSign,
        priceCompareFlag: this.query.priceCompareFlag,
      };
      const res = await Api.getSharedAgreementProductList(params);

      if (res.data) {
        this.loading1 = false;
        this.tableData1 = res.data.records;
        if (this.agreementOrigin) {
          for (let i = 0; i < this.tableData1.length; i++) {
            this.$set(this.tableData1[i], 'agreementPrice', this.agreementPrice);
          }
        }
        this.productTagPage1.pageTotal = res.data.total;
        if (this.checkAll) {
          this.$refs.tableList.$refs.table.toggleAllSelection();
        }
      }
    },
    handleAddProduct() {
      this.productListDialogShow = true;
    },
    closeProductListDialog() {
      this.productListDialogShow = false;
    },
    handleAdjustPrice(val) {
      this.priceId = val.priceId;
      this.supplierCompanyId = this.agreementDetail.secondCompanyId;
      this.adjustPriceDialogShow = true;
    },
    handleConfirm() {
      const params = {
        agreementId: this.agreementId,
      };
      for (let i = 0; i < this.tableData1.length; i++) {
        if (!this.tableData1[i].agreementTempPrice) {
          this.$message({
            type: 'warning',
            message: '请填写协议价',
          });
          return;
        }
      }
      Api.submitSharedAgreement(params).then((res) => {
        if (res.code == '200') {
          this.$message({
            type: 'success',
            message: '提交确认成功',
          });
          this.$router.push({ path: '/sharedResourceAgreementManage' });
        }
      });
      // }
    },
    handleCancel() {
      this.tableData1.length = 0;
      this.goToUrl();
    },
    goToUrl() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
    adjustAgreementPrice(val) {
      const params = {
        priceId: val.priceId,
        agreementPrice: parseFloat(val.agreementPrice),
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
      };

      Api.updateAgreementPriceByAdd(params).then((res) => {
        if (res.code == '200') {
          this.$message({
            type: 'success',
            message: '更新协议价成功',
          });
        }
      });
    },
    closeAdjustPriceDialog() {
      this.adjustPriceDialogShow = false;
      setTimeout(() => {
        this.getProductPriceList();
      }, 2000);
    },
    handleDownload(val) {
      window.open(val);
    },
    async getAgreementDetail() {
      const params = {
        agreementId: this.agreementId,
      };
      const res = await Api.getSharedAgreementDetail(params);

      if (res.data) {
        this.agreementDetail = res.data;
        this.agreementOrigin = this.agreementDetail.source
          ? this.agreementDetail.source == 'SL' || this.agreementDetail.source == 'SC'
          : false;
        this.tableData = res.data.agreementMembers;
      }

      this.getProductPriceList();
    },
    async getCategoryList() {
      const params = {
        agreementId: this.agreementId,
        pageSize: this.pager.pageSize,
        pageNum: this.pager.currentPage,
      };
      const res = await Api.getCategoryList(params);

      if (res.data) {
        this.tableData4 = res.data;
        this.pager.pageTotal = res.data.total;
      }
    },
    handleMultiAdjustPrice() {
      if (this.checkedSkuPriceMap.length === 0) {
        this.$message({
          message: '请先勾选要调价的商品',
          type: 'warning',
        });
        return;
      }
      this.multiAdjustPriceDialogShow = true;
      const priceArr = this.checkedSkuPriceMap.map((item) => item.skuPrice);

      this.adjustPrice = Math.min(...priceArr);
    },
    handleCheckAllChange(val) {
      console.log(val);
      this.checkAll = val;
      if (val) {
        this.$refs.tableList.$refs.table.toggleAllSelection();
        // this.getAllProductPriceList()
      } else {
        this.checkedSkuPriceMap = []; // 清空当前列表页选择的数据项
        this.$refs.tableList.$refs.table.clearSelection(); // 清除全部的选中状态
      }
    },

    // 删除操作
    async delHandle(row) {
      // 区分 1.点击列表删除按钮 2.点击顶部删除按钮 2.1全部数据删除 this.checkAll/ removeByCondition 2.2当前页选择删除
      const { id = '' } = row;
      const params = {
        agreementId: this.agreementId,
        pageSize: this.productTagPage1.pageSize,
        pageNum: this.productTagPage1.currentPage,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
        brandName: this.query.brandName,
        companyShowCode: this.query.companyShowCode,
        confirmStatus: this.query.confirmStatus,
      };
      // 点击列表的删除按钮
      if (id) {
        params.idList = [id];
        this.delItemHandle(params);
      } else {
        // 数据全部删除
        if (this.checkAll) {
          delete params.idList;
          const result = await Api.removeByCondition(params);
          if (result.code === '200') {
            this.checkAll = false;
            this.$message({
              message: '删除成功！',
              type: 'success',
            });
            this.getProductPriceList();
          }
        } else {
          // 选取当前页面数据删除
          const idList = this.checkedSkuPriceMap.map((item) => item.id);
          if (idList.length == 0) {
            this.$message({
              message: '请先勾选要删除的商品',
              type: 'warning',
            });
            return;
          }

          params.idList = idList;
          this.delItemHandle(params);
        }
      }
    },

    async delItemHandle(params) {
      const result = await Api.batchRemove(params);
      if (result.code === '200') {
        this.$message({
          message: '删除成功！',
          type: 'success',
        });
        this.getProductPriceList();
      }
    },

    // 批量调价
    multiAdjustPrice: _.debounce(async function (val) {
      console.log('val:', val);
      const params = {};
      if (this.checkAll) {
        let arr = [];
        if (this.query.code) {
          const s = this.query.code.replace(/\n/g, '@');
          arr = s.split('@');
        }
        params.percentage = val.percentage;
        params.supplierCompanyId = this.agreementDetail.secondCompanyId;
        params.changePrice = val.adjustmentPrice;
        params.type = val.adjustmentType;
        params.basePriceType = val.basePriceType;

        params.shareSkuAOList = [];
        params.companyShowCode = this.query.companyShowCode;

        params.skuCodeList = arr;
        params.categoryIdList = this.query.categoryIdList;
        params.brandName = this.query.brandName;
        params.skuName = this.query.skuName;
        params.confirmStatus = this.query.confirmStatus;

        const res = await Api.sharedAgreementAllProductAdjustPrice(params);

        if (res.code === '200') {
          this.multiAdjustPriceDialogShow = false;
          this.checkAll = false;
          this.$message({
            message: '多维度调价成功！',
            type: 'success',
          });

          this.$refs.multiAdjustPrice.$refs.priceForm.resetFields();
          this.clearTable();
          setTimeout(() => {
            this.getProductPriceList();
          }, 1000);
        }
      } else {
        params.percentage = val.percentage;
        params.supplierCompanyId = this.agreementDetail.secondCompanyId;
        params.changePrice = val.adjustmentPrice;
        params.type = val.adjustmentType;
        params.shareSkuAOList = this.checkedSkuPriceMap;
        params.basePriceType = val.basePriceType;

        params.companyShowCode = this.query.companyShowCode;
        params.confirmStatus = this.query.confirmStatus;
        const res = await Api.sharedAgreementProductAdjustPrice(params);
        if (res.code === '200') {
          this.multiAdjustPriceDialogShow = false;
          this.$message({
            message: '多维度调价成功！',
            type: 'success',
          });
          this.$refs.multiAdjustPrice.$refs.priceForm.resetFields();
          this.clearTable();
          setTimeout(() => {
            this.getProductPriceList();
          }, 1000);
        }
      }
    }, 500),

    clearTable() {
      if (this.checkAll) {
        this.$nextTick(() => {
          this.tableData1.map((item, index) => {
            this.$refs.tableList.$refs.table.toggleRowSelection(this.tableData1[index], true);
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.tableList.$refs.table.clearSelection(); // 清除全部的选中状态
        });
      }
      /* this.checkedSkuPriceMap = []; // 清空当前列表页选择的数据项
      this.$refs.table.$refs.table.clearSelection(); // 清除全部的选中状态
      this.checkAll = false; */
    },
    async getAllProductPriceList() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.secondCompanyId,
        materialCode: this.materialCode,
      };
      const res = await Api.getAllProductPriceList(params);

      if (res.data) {
        this.checkedSkuPriceMap = res.data;
      }
    },
    async getCheckedDataCount() {
      const params = {
        agreementId: this.agreementId,
        supplierCompanyId: this.agreementDetail.secondCompanyId,
        materialCode: this.materialCode,
      };
      const res = await Api.getAllProductPriceList(params);

      if (res.data) {
        this.checkAllCount = res.data.length;
      }
    },
    handleClose() {
      this.multiAdjustPriceDialogShow = false;
      this.clearTable();
      setTimeout(() => {
        this.getProductPriceList();
      }, 2000);
    },
    handleSelect(rows) {
      if (this.checkAllCount == rows.rows.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleSearch(val) {
      console.log(val, 'val');
      this.query = { ...val };
      this.productTagPage1.pageSize = 10;
      this.productTagPage1.currentPage = 1;
      this.getProductPriceList();
    },
    handleClear() {
      this.query.skuCode = '';
      this.query.code = '';
      this.query.skuCodeList = [];
      this.query.skuName = '';
      this.query.categoryName = '';
      this.query.brandName = '';
      this.query.categoryIdList = null;
      this.query.companyShowCode = '';
      this.query.confirmStatus = '';
      this.query.priceCompareFlag = null;
      this.query.systemSign = null;
      this.productTagPage1.pageSize = 10;
      this.productTagPage1.currentPage = 1;
      this.getProductPriceList();
    },
    exportFile() {
      // let params = this.formatParams();
      let arr = [];
      if (this.query.code) {
        const s = this.query.code.replace(/\n/g, '@');
        arr = s.split('@');
      }
      const params = {
        agreementId: this.agreementId,
        pageSize: this.productTagPage1.pageSize,
        pageNum: this.productTagPage1.currentPage,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
        brandName: this.query.brandName,
        companyShowCode: this.query.companyShowCode,
        confirmStatus: this.query.confirmStatus,
        skuCodeList: arr,
      };
      Api.sharedAgreementExportProduct(params).then((res) => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res);
        }
      });
    },
    formatParams() {
      const res = {};
      res.pageNum = this.pager.currentPage;
      res.pageSize = this.pager.pageSize;
      res.agreementId = this.agreementId;
      res.skuName = this.query.skuName;
      res.skuCode = this.query.skuCode;
      res.categoryIdList = this.query.categoryIdList;
      res.brandName = this.query.brandName;
      return res;
    },
    checkCategoryList() {
      this.checkCategoryDialog = true;
    },
    checkAttachList() {
      this.checkAttachDialog = true;
    },
    handleStop(val) {
      this.$confirm('确认停用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            id: val.id,
          };
          Api.stopSharedAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '停用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '停用失败!',
              });
            }
            this.getProductPriceList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消停用',
          });
        });
    },
    handleStart(val) {
      this.$confirm('确认启用吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const params = {
            id: val.id,
          };
          Api.startSharedAgreement(params).then((res) => {
            if (res.code === '200') {
              this.$message({
                type: 'success',
                message: '启用成功!',
              });
            } else {
              this.$message({
                type: 'error',
                message: '启用失败!',
              });
            }
            this.getProductPriceList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用',
          });
        });
    },
    formatStatus(val) {
      let res = '';
      switch (val) {
        // case 0: res='待维护商品';break;
        case 1:
          res = '待生效';
          break;
        case 2:
          res = '已生效';
          break;
        case 3:
          res = '已失效';
          break;
        // case 4: res='待审核商品';break;
        case 5:
          res = '已停用';
          break;
      }
      return res;
    },
    formatSecondCompanyType(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '生产商';
          break;
        case 1:
          res = '流通商';
          break;
        case 2:
          res = '代理商';
          break;
      }
      return res;
    },
    formatSource(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '框架协议';
          break;
        case 1:
          res = '系统集成';
          break;
        case 2:
          res = '平台自注册';
          break;
      }
      return res;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },

    // 所属分类确定
    classifySubmitPopupData(val) {
      // this.defaultCheckedKeys = val.map(item=>item.categoryId)
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      console.log(filterNode, '过滤后的categoryId');
      this.query.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.query.categoryName = arr.join('、');
      this.classifyVisible = false;
    },
    async getAllCategoryTree() {
      const params = {
        agreementId: this.agreementId,
      };
      const res = await Api.getSharedResourceAllCategoryTree(params);
      if (res.code == '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.query.categoryIdList?.length) {
        this.defaultCheckedKeys = this.query.categoryIdList;
      }
      this.classifyVisible = true;
    },

    handleDisable() {
      if (this.checkedSkuPriceMap.length === 0) {
        this.$message({
          message: '请先勾选要停用的商品',
          type: 'warning',
        });
        return;
      }
      this.$confirm('确认停用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (this.checkAll) {
            this.disableByCondition();
          } else {
            this.disableBatch();
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消停用',
          });
        });
    },
    disableBatch() {
      const arr = [];
      this.checkedSkuPriceMap.forEach((item) => {
        arr.push(item.id);
      });
      Api.disableBatch({ idList: arr }).then((res) => {
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '停用成功!',
          });
        } else {
          this.$message({
            type: 'error',
            message: '停用失败!',
          });
        }
        this.getProductPriceList();
      });
    },
    disableByCondition() {
      let arr = [];
      if (this.query.code) {
        const s = this.query.code.replace(/\n/g, '@');
        arr = s.split('@');
      }
      const params = {
        agreementId: this.agreementId,
        pageSize: this.productTagPage1.pageSize,
        pageNum: this.productTagPage1.currentPage,
        skuCode: this.query.skuCode,
        skuName: this.query.skuName,
        categoryIdList: this.query.categoryIdList,
        brandName: this.query.brandName,
        companyShowCode: this.query.companyShowCode,
        confirmStatus: this.query.confirmStatus,
        skuCodeList: arr,
      };
      Api.disableByCondition(params).then((res) => {
        if (res.code === '200') {
          this.$message({
            type: 'success',
            message: '停用成功!',
          });
        } else {
          this.$message({
            type: 'error',
            message: '停用失败!',
          });
        }
        this.getProductPriceList();
      });
    },

    inputChange(val) {
      console.dir(val.replace(/\n/g, '@'));
      // val=val.replace(" ",/\n/g)
      // val=val.replace('<br/>',/\n/g)
      // console.log("第一行\n第二行");
      // this.query.skuCode = this.query.skuCode.replace(/\n/g, '<br/>')
      // this.query.skuCode = this.query.skuCode.replace(new RegExp(' ', 'gm'), '&nbsp;')

      // this.query.skuCode=val.replace(new RegExp(' ', 'gm'),'<br/>')
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .agreement-container {
    background: #fff;
    margin-bottom: 10px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    width: 100%;
    display: flex;
    flex-direction: column;
    /*align-items: center;*/
    padding: 20px 20px;
    .container-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
      width: 100%;
    }
    .container-btn {
      width: 100%;
      margin-bottom: 10px;
    }
    .container-body {
      width: 100%;
      .el-input-width {
        width: 266px;
        height: 28px;
      }
      .container-purchase {
        background: #f8f8f8;
        width: 725px;
        height: 424px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        .left {
          width: 308px;
          height: 360px;
          background-color: #ffffff;
          padding: 10px 10px 10px;
          .search {
            width: 100%;
            .scrollbar {
              height: 242px;
              overflow: hidden;
            }
          }
        }
        .right {
          width: 298px;
          height: 360px;
          background-color: #ffffff;
          padding: 10px 10px 10px;
          .scrollbar {
            height: 316px;
            overflow: hidden;
            .scrollbar-li {
              display: flex;
              justify-content: space-between;
              cursor: pointer;
            }
            .scrollbar-active {
              background: #f4f7ff;
            }
          }
        }
        .middle {
          width: 60px;
          height: 360px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            height: 35px;
            width: 18px;
          }
        }
        .tip {
          font-size: 14px;
          color: #999999;
        }
      }
      .tabs-area {
        margin-bottom: 20px;
        .scrollbar {
          height: 290px;
          overflow: hidden;
          .table {
            display: flex;
            flex-direction: row;
          }
        }
      }
    }
    .step {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 30px;
      ::v-deep .step-container .el-step__head.is-process .el-step__line {
        border: 1px solid #2587ff;
        // left: 65%;
        background-color: transparent;
        margin-right: 45px !important;
        margin-left: 45px;
        top: 13px;
        // width: 150px;
      }
      ::v-deep .step-container .el-step__head.is-process .el-step__icon {
        width: 30px;
        height: 30px;
        color: #ffffff;
        border: 1px solid #2587ff;
        background: #2587ff;
      }
      ::v-deep .step-container .el-step__head.is-wait .el-step__line {
        border: 1px dashed #c5c5c5;
        // left: 65%;
        background-color: transparent;

        margin-right: 45px !important;
        margin-left: 45px;
        top: 13px;
        // width: 150px;
      }
      ::v-deep .step-container .el-step__head.is-wait .el-step__icon {
        width: 30px;
        height: 30px;
        color: #c5c5c5;
        border: 1px solid #c5c5c5;
      }
      ::v-deep .step-container .el-step__icon {
        width: 30px;
        height: 30px;
        border: 1px solid #d9d9d9;
        // background-color: transparent;
        background-color: #ededed;
      }
      ::v-deep .step-container.el-step__icon.is-text {
        border: 1px solid #d9d9d9;
      }
      ::v-deep .step-container.el-step__icon-inner {
        color: #c5c5c5;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

.scrollbar ::v-deep .el-scrollbar__wrap {
  overflow: hidden;
  margin-right: 0 !important;
}
.scrollbar ::v-deep .el-scrollbar__bar.is-vertical {
  background: #f5f5f5;
  border-radius: 2px;
  width: 3px;
  opacity: 1;
  margin-right: -2px;
}
.scrollbar ::v-deep .el-scrollbar__bar.is-horizontal {
  background: #f5f5f5;
  border-radius: 2px;
  height: 3px;
  margin-bottom: -2px;
  &:hover {
    opacity: 0;
  }
}
.tabs-area ::v-deep .el-tabs__header {
  margin: 0 0 0 !important;
}
.tabs-area ::v-deep .el-tabs__header .el-tabs__nav {
  border-radius: 0 !important;
}
.table ::v-deep .el-table__empty-block {
  min-height: 0 !important;
}
.table ::v-deep .el-table__empty-text {
  display: none;
}
::v-deep {
  .el-rate__icon {
    font-size: 20px;
    margin-right: 2px;
  }

  .tabs-area {
    .el-tabs__nav {
      border-radius: 0;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav .el-tabs__item {
      width: 176px;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      height: 40px;

      &.is-active {
        background: #f4f7ff;
        color: #0064c8;
      }

      &.is-active::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
    .el-tabs__content {
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .search_box {
    width: 100%;
    padding: 20px 30px;
    border: 1px solid #f5f5f5;
    margin-bottom: 10px;
    display: flex;
    .sku_code {
      display: flex;
      float: left;
      .text {
        width: 72px;
        color: #333;
        font-size: 14px;
      }
      .text_input {
        font-size: 13px;
        width: 315px;
      }
    }
  }
}
.pre-line {
  white-space: pre-line;
}
</style>
